import React from "react";
import { ISubmissionProps } from "@model/UIComponents.model";
import styles from "./UiLibraryComponent.module.css";

const Submission: React.FC<ISubmissionProps> = ({
  buttonText,
  disabled = false,
  loading = false,
  error,
  onClick,
  className = "",
  type = "submit", 
}) => {
  const isDisabled = disabled || loading;
  return (
    <div className={styles.submitContainer}>
      {error && (
        <p className={styles.errorMessage} data-testid="submission-error">
          {error}
        </p>
      )}

      <button
        type={type}
        disabled={isDisabled}
        onClick={isDisabled ? undefined : onClick}
        className={`${styles.submitButton} ${
          isDisabled ? styles.buttonDisabled : ""
        } ${className}`}
        data-testid="submission-button"
      >
        {loading ? "Saving…" : buttonText}
      </button>
    </div>
  );
};

export default Submission;
